module.exports = __webpack_public_path__ + "img/project4_1.e73a6d72.gif";